import { IAdditionalCodesItemReturn } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const retrieveAdditionalCodes = async ({ id }: { id: string }): Promise<IAdditionalCodesItemReturn[]> => {
  try {
    const result = await apiClient.batchesFinalization.retrieveAdditionalCodes.mutation({ params: { id } });
    if (result.status !== 200) throw result.body;

    return result.body.data;
  } catch (error) {
    showErrorToast(error, 'Error fetching the additional codes!');
  }
};
